module.exports = __webpack_public_path__ + "static/media/sound4.6f45b389.mp3";